import React from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../LayoutAside"
import KmcisLink, {KmcisConfirmResult} from "components/kmics";

export default ContentsContainer;

function ContentsContainer(props: any) {
    const onCallbackHandler = (result: KmcisConfirmResult, confirmed: boolean) => {
        console.log(confirmed, result);
    }

    return (
        <PageContainer session={false}>
            <LayoutAside/>
            <div className="fww-con">
                <main className="fww-main">
                    <div className="fo fo-col3 mb10">
                        <KmcisLink
                            color={`pri`}
                            size={`big`}
                            className={`bt`}
                            urlCodeType={"0"}
                            callback={onCallbackHandler}>
                            휴대폰 인증하기
                        </KmcisLink>
                    </div>
                </main>
            </div>
        </PageContainer>
    )
}
